
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/truck-driving-jobs/[[...state]]",
      function () {
        return require("private-next-pages/truck-driving-jobs/[[...state]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/truck-driving-jobs/[[...state]]"])
      });
    }
  